<template>
    <div>
        <v-modal v-if="!!showModal" :show="!!showModal" @close="handleCloseModal">
            <p slot='header'> {{ call.title }} {{ call.external_call_id }} </p>
            <div slot="body">
                <p v-if="call.candidate_info" style="font-size:20px;">
                    {{ call.candidate_info.text }}
                </p>
                <p v-if="call.driver_info" style="font-size:20px;">
                    {{ call.driver_info.text }}
                </p>
            </div>
            <div slot="footer" class="flex-right">
                <button class="button button_size_ex-large button_color_white" @click='handleCloseModal'>Закрыть</button>
                <button class="button button_size_ex-large button_color_black" @click="handleApply(call)">Перейти</button>
            </div>
        </v-modal>
        <v-end-call-modal v-if="!!ShowEndCallModal" @close="handleCloseEndModal" :callparams="call" /> <!-- uuid -->
    </div>
</template>

<script>
import vEndCallModal from '@components/global/vEndCallModal.vue'
import VModal from '@components/global/Modal'

import { eventBus } from '@eventBus'
import { mapState } from 'vuex'

export default { 
    components: { VModal, vEndCallModal },
    data() {
        return {
            ShowEndCallModal: '',
            showModal: false,
            call: null,
        }
    },
    mounted() {
        eventBus.$on('incomingCall', this.incomingCall);
        eventBus.$on('endCall', this.endCall);
    },
    methods: {
        ...mapState({
            user: state => state.profile.user
        }),
        incomingCall(e) {
            const { action, type, driver_info, candidate_info, company_id, user_id, title } = e
            this.call = { action, type, driver_info, candidate_info, company_id, user_id, title } 
            this.call.external_call_id = e.external_call_id // для новой телефонии
            this.call.uuid = e.uuid // для старой телефонии
            if(!this.$store.getters.user.permissions.telephony_access_to_call_management) this.showModal = true
        },

        handleCloseModal() {
            //this.call = null
            this.showModal = false
        },
        endCall() {
            this.ShowEndCallModal = true
        },
        handleCloseEndModal() {
            this.ShowEndCallModal = false
            this.call = null
        },
        handleApply(call) {
            let route = null
            if (call.type == 'candidate') {
                const { id } = call.candidate_info
                route = { name: 'CandidateEdit', query: { id } }
            } else {
                const { id, park_id } = call.driver_info
                route = { name: "DriverDetail", query: { driver_id: id, park_id } }
            }
            this.$router.push(route)
            this.handleCloseModal()
        },

    },
}
</script>

<style lang="scss" scoped></style>